import { render, staticRenderFns } from "./CarfaxSourceEvidence.vue?vue&type=template&id=b736c060&scoped=true"
import script from "./CarfaxSourceEvidence.vue?vue&type=script&lang=js"
export * from "./CarfaxSourceEvidence.vue?vue&type=script&lang=js"
import "./CarfaxSourceEvidence.vue?vue&type=style&index=0&id=b736c060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b736c060",
  null
  
)

export default component.exports